import React, {useState, useEffect, useImperativeHandle, forwardRef} from "react"
import ZkFormItem from "../../../../../common/form/zkFormItem";
import {Input, Select, Space} from "antd";
import IconSearch from "../../../../../../iconfont/search";
import CloudApi from "../../../../cloud_api";
import Message from "../../../../../common/message";

const {Option} = Select;
const {Search} = Input;
const CustomerTag = forwardRef((props, ref) => {
    const {
        activeState: activeState,//活动的状态  主要用于编辑的时候禁用
        type: type,//类型 用于判断是客户的还是群聊的
        echoData: echoData,//回显的数据
        className: className, //最外层的className
    } = props
    const [tagFilterType, setTagFilterType] = useState('1')
    const [customerTag, setCustomerTag] = useState([])
    const [tagName, setTagName] = useState('')//搜索标签的字段
    const [selectTag, setSelectTag] = useState([])//选中的标签字段  数组
    const [value, setValue] = useState([])//选中的标签展示  只要名字
    const [tagId, setTagId] = useState([])//选中的标签ID数组
    const [disabled, setDisabled] = useState(false)//禁用的
    useEffect(() => {
        if (echoData) {
            if (echoData.tags && echoData.tags.length == 0) {
                setValue([])
                setTagId([])
                setSelectTag([])
                let newCustomerTag = customerTag
                if (newCustomerTag.length > 0) {
                    newCustomerTag.forEach((item) => {
                        item.tag && item.tag.forEach(el => {
                            el.flag = false
                        })
                    })
                }
                setCustomerTag(newCustomerTag)
            }
            if (echoData.tagId && echoData.tagId.length > 0) {
                echoData.tagId.forEach(item => {
                    item.name = item.tagName || item.tagname
                    item.id = item.tagId || item.userId
                    item.flag = true
                })
                setSelectTag(echoData.tagId)
            } else {
                /**
                 * @Description: 客户管理 新加逻辑。如果回显的tag为空，全部重置，清空数据
                 * @author Shi_qshan
                 * @date 2022/8/24
                 */
                //清空数据
                // setSelectTag([])
                // setValue([])
                // setTagId([])
                //
                // let data = JSON.parse(JSON.stringify(customerTag))
                // data.forEach((item) => {
                //     item.tag.forEach((el, ind) => {
                //         el.flag = false
                //     })
                // })
                // setCustomerTag(data)
            }
            setTagFilterType(echoData.tagFilterType || echoData.tagFilterType == 0 ? echoData.tagFilterType.toString() : '1') //回显的标签类型
            if (echoData.tagFilterType == 0) {
                setDisabled(true)
            }
            if (echoData.tagId && echoData.tagId.length > 0) {
                setTagId(echoData.tagId ? echoData.tagId : []) //回显的标签id
                let names = []
                echoData.tagId.forEach((item) => {
                    names.push(item.tagName || item.tagname)
                })
                setValue(names)
                if (type == 'customer') {
                    CloudApi.getAccountPhoneFriendCorpTags('', (data) => {
                        data.tagGroup && data.tagGroup.forEach((item, index) => {
                            item.tag && item.tag.forEach((el, ind) => {
                                el.tagName = el.name
                                el.tagId = el.id
                                el.flag = false
                                echoData.tagId && echoData.tagId.forEach((e) => {
                                    if (el.tagId == e.tagId) {
                                        el.flag = true
                                    }
                                })
                            })
                        })
                        setCustomerTag(data.tagGroup)
                    }, () => {
                        Message.error('获取客户标签失败')
                    })
                } else if (type == 'group') {
                    //获取标签列表
                    CloudApi.getGroupTagQuery({name: ''}, (data) => {
                        data.tagGroup && data.tagGroup.forEach((item, index) => {
                            item.tag && item.tag.forEach((el, ind) => {
                                el.tagName = el.name
                                el.tagId = el.id
                                el.flag = false
                                echoData.tagId && echoData.tagId.forEach((e) => {
                                    if (el.tagId == e.tagId) {
                                        el.flag = true
                                    }
                                })
                            })
                        })
                        setCustomerTag(data.tagGroup)
                    }, () => {
                        Message.error('获取群聊标签失败！')
                    })
                }
            }
        }

    }, [echoData])
    useEffect(() => {
        if (activeState == 'create' || activeState == 'notDisable') {
            getCustomerTag()//获取标签
        }
    }, [])
    useImperativeHandle(ref, () => ({
        exportRadio: exportRadio,
        exportTagId: exportTagId,
        echoList: echoList
    }))

    //抛出标签筛选类型
    function exportRadio() {
        return Number(tagFilterType)
    }

    //抛出选择的标签
    function exportTagId() {
        return JSON.parse(JSON.stringify(selectTag))
    }

    //获取标签
    function getCustomerTag() {
        if (type == 'customer') {
            CloudApi.getAccountPhoneFriendCorpTags('', (data) => {
                accessLabel(data.tagGroup)
            }, () => {
                Message.error('获取客户标签失败')
            })
        } else if (type == 'group') {
            //获取标签列表
            CloudApi.getGroupTagQuery({name: ''}, (data) => {
                accessLabel(data.tagGroup)
            }, () => {
                Message.error('获取群聊标签失败！')
            })
        }
    }

    //存标签
    function accessLabel(data) {
        data && data.forEach((item) => {
            item.tag && item.tag.forEach((el, ind) => {
                el.tagId = el.id
                el.tagName = el.name
                el.flag = false
                if (echoData != undefined) {
                    echoData.tagId && echoData.tagId.forEach((e) => {
                        if (el.tagId == e.tagId) {
                            el.flag = true
                        }
                    })
                }
            })
        })
        setCustomerTag(data)
    }

    //标签筛选类型
    function handleChange(e) {
        if (e == 0) {
            setSelectTag([])
            setTagId([])
            setValue([])
            setDisabled(true)
        } else {
            setDisabled(false)
        }
        setTagFilterType(e)

    }

    //搜索出来的内容
    function searchData(data) {
        data.tagGroup && data.tagGroup.forEach((item, index) => {
            item.tag && item.tag.forEach((el, ind) => {
                el.tagName = el.name
                el.tagId = el.id
                el.flag = false
                selectTag && selectTag.forEach((tagItem) => {
                    if (el.id == tagItem.id) {
                        el.flag = true
                    }
                })
            })
        })
        setCustomerTag(data.tagGroup)
    }

    //搜索标签的时间
    function tagNameChange(e) {
        setTagName(e.target.value)
        if (e.target.value == '') {
            if (type == 'customer') {
                CloudApi.getAccountPhoneFriendCorpTags('', (data) => {
                    searchData(data)
                }, () => {
                    Message.error('获取客户标签失败')
                })
            } else if (type == 'group') {
                CloudApi.getGroupTagQuery({name: ''}, (data) => {
                    searchData(data)
                }, () => {
                    Message.error('获取群聊标签失败！')
                })
            }
        }
    }

    //点击标签
    function tagClick(e) {
        let newData = [...customerTag]//全部标签
        let newSelectTag = selectTag //获取已经选中的
        newData.forEach((item) => {
            item.tag.forEach((el, ind) => {
                if (el.tagId == e) {
                    el.flag = !el.flag
                    if (el.flag) {
                        newSelectTag.push(el)
                        setSelectTag(newSelectTag)

                        let newValue = value
                        newValue.push(el.name)
                        setValue(newValue)

                        let newTagId = tagId
                        // newTagId.push({
                        //     tagId:el.id,
                        //     tagName:el.name
                        // })
                        // setTagId(newTagId)
                    } else {
                        let names = []//没选中的名字
                        let ids = []//没选中的id
                        newSelectTag = selectTag.filter(tagItem => tagItem.tagId != e)
                        newSelectTag.forEach((unselected) => {
                            names.push(unselected.name)
                            ids.push({
                                tagId: unselected.id,
                                tagName: unselected.name
                            })
                        })
                        setValue(names)
                        setTagId(ids)
                        setSelectTag(newSelectTag)
                    }
                }
            })
        })
        setCustomerTag(newData)
    }

    //清空选中的标签
    function clearSelectTag(e) {
    }

    //搜索标签按下回车事件
    function pressEnterEvent() {
        if (tagName != '') {
            if (type == 'customer') {
                CloudApi.getAccountPhoneFriendCorpTags(tagName, (data) => {
                    searchData(data)
                }, () => {
                    Message.error('获取客户标签失败')
                })
            } else if (type == 'group') {
                CloudApi.getGroupTagQuery({name: tagName}, (data) => {
                    searchData(data)
                }, () => {
                    Message.error('获取群聊标签失败！')
                })
            }

        }
    }

    function echoList(data) {

    }

    return (
        <div className={`customer_tag ${className}`}>
            <ZkFormItem
                title={props.title != undefined ? props.title : type == 'customer' ? '客户标签：' : type == 'group' ? '群聊标签：' : ''}
                colon={false}
                titleWidth={props.titleWidth ? props.titleWidth : '120px'}
                conWidth={props.conWidth ? props.conWidth : '410px'}
            >
                <div className={'customer_tag_content'}>
                    <div>
                        <Select
                            disabled={(activeState == 'create' || activeState == 'notDisable') ? false : true}
                            value={tagFilterType}
                            style={{width: 120, border: 'none'}}
                            onChange={handleChange}
                            getPopupContainer={triggerNode => triggerNode.parentNode}
                        >
                            <Option value="1">含任意标签</Option>
                            <Option value="2">含所有标签</Option>
                            <Option value="0">未打标签</Option>
                        </Select>
                    </div>
                    <div>
                        <Select
                            placeholder={'请选择标签'}
                            disabled={
                                (activeState == 'create' || activeState == 'notDisable') && tagFilterType != 0 ?
                                    false :
                                    (activeState == 'create' || activeState == 'notDisable') && tagFilterType == 0 ?
                                        true :
                                        activeState == 'edit' ?
                                            true : false
                            }
                            className={'change_default_style'}
                            mode="multiple"
                            style={{width: '100%'}}
                            value={value}
                            dropdownMatchSelectWidth={false}
                            dropdownClassName={'dropdown-style'}
                            removeIcon={false}
                            getPopupContainer={triggerNode => triggerNode.parentNode}
                        >
                            <Option disabled={true} className={'opt_disabled'} key={4}>
                                <div className={'contents_drop_down_box'}>
                                    <div className={'drop_down_menu_contents'}>
                                        <Space>
                                            <Search
                                                prefix={<></>}
                                                placeholder="搜索标签"
                                                style={{width: 263}}
                                                value={tagName}
                                                onChange={tagNameChange}
                                                virtual={false}
                                                onPressEnter={pressEnterEvent}
                                                onSearch={pressEnterEvent}
                                            />
                                        </Space>
                                    </div>
                                    {customerTag.length == 0 ? <div>暂无数据</div> :
                                        <div className={'tag_format'}>
                                            {
                                                customerTag && customerTag.map((item, index) => {
                                                    return <div key={item.groupId}>
                                                        <label>{item.groupName}</label>
                                                        <div>
                                                            {item.tag && item.tag.map((el, ind) => {
                                                                return <label
                                                                    style={{
                                                                        color: el.flag ? '#1673FF' : '',
                                                                        border: el.flag ? '1px solid #1673FF' : ''
                                                                    }}
                                                                    key={el.tagId}
                                                                    onClick={tagClick.bind(this, el.tagId)}>
                                                                    {el.tagName}
                                                                </label>
                                                            })}
                                                        </div>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    }
                                </div>
                            </Option>
                        </Select>
                    </div>
                </div>
            </ZkFormItem>
        </div>
    )
})
export default CustomerTag